import React from 'react';
import styled from '@benzinga/themetron';
import { StoryObject } from '@benzinga/basic-news-manager';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface NewsTitleAuthorProps {
  node: StoryObject;
}

export const NewsTitleAuthor: React.FC<NewsTitleAuthorProps> = ({ node }) => {
  return (
    <Container className="news-title-author">
      <TitleContainer className="title-container">
        {node?.title && <a dangerouslySetInnerHTML={{ __html: sanitizeHTML(node.title) }} href={node.url} />}
      </TitleContainer>
      <Author>{node.author}</Author>
    </Container>
  );
};

const TitleContainer = styled.div`
  line-height: 1.1;
  a {
    color: #3f83f8;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 0.2rem;
    &:hover {
      color: #3364b9;
    }
  }
`;

const Author = styled.div`
  font-size: 11px;
`;

const Container = styled.div``;
